import React from 'react';
import styled from 'styled-components';
import { Button } from './styles';

const TemplateHistory = ({ templates, onEdit, onDelete, onCreateNew }) => {
  return (
    <TemplatesListContainer>
      <TemplateHeaderContainer>
        <h2>Your Templates</h2>
        <Button onClick={onCreateNew}>Create New Template</Button>
      </TemplateHeaderContainer>
      
      {templates.length === 0 ? (
        <EmptyState>
          <p>No templates created yet. Create your first template!</p>
          <Button onClick={onCreateNew}>Create Template</Button>
        </EmptyState>
      ) : (
        <TemplatesGrid>
          {templates.map(template => (
            <TemplateCard key={template.id}>
              <TemplateCardHeader>
                <TemplateName>{template.name}</TemplateName>
                <TemplateActions>
                  <ActionButton onClick={() => onEdit(template)}>
                    Edit
                  </ActionButton>
                  <ActionButton onClick={() => onDelete(template.id)}>
                    Delete
                  </ActionButton>
                </TemplateActions>
              </TemplateCardHeader>
              
              {template.description && (
                <TemplateDescription>{template.description}</TemplateDescription>
              )}
              
              <TemplateSubject>
                <strong>Subject:</strong> {template.subject}
              </TemplateSubject>
              
              <TemplateMetadata>
                <div>Created: {new Date(template.createdAt).toLocaleDateString()}</div>
                <div>Updated: {new Date(template.updatedAt).toLocaleDateString()}</div>
              </TemplateMetadata>
            </TemplateCard>
          ))}
        </TemplatesGrid>
      )}
    </TemplatesListContainer>
  );
};

export default TemplateHistory;

// Component-specific styled components
const TemplatesListContainer = styled.div`
  width: 100%;
`;

const TemplateHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  h2 {
    margin: 0;
    color: #333;
  }
`;

const EmptyState = styled.div`
  background: #f9f9f9;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  color: #666;
  border: 1px dashed #ccc;
  
  button {
    margin-top: 16px;
  }
`;

const TemplatesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
`;

const TemplateCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border: 1px solid #eee;
  transition: transform 0.2s, box-shadow 0.2s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
`;

const TemplateCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

const TemplateName = styled.h3`
  margin: 0;
  font-size: 16px;
  color: #333;
`;

const TemplateActions = styled.div`
  display: flex;
  gap: 8px;
`;

const ActionButton = styled.button`
  padding: 4px 8px;
  background-color: transparent;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: #f5f5f5;
    border-color: #999;
  }
`;

const TemplateDescription = styled.p`
  margin: 8px 0;
  font-size: 14px;
  color: #666;
`;

const TemplateSubject = styled.div`
  margin: 8px 0;
  font-size: 14px;
  word-break: break-word;
`;

const TemplateMetadata = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #888;
  margin-top: 12px;
  border-top: 1px solid #eee;
  padding-top: 12px;
`; 